import { Component, OnInit } from "@angular/core";
import { Prospeccion } from "../models/prospeccion";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { GestionclientesService } from "../gestionclientes.service";
import { MatDatepickerInputEvent, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from "@angular/material/datepicker";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { NgFor, NgIf, DatePipe } from "@angular/common";
import { NgxPaginationModule } from "ngx-pagination";

@Component({
    selector: 'app-gestion-prospeccion',
    standalone: true,
    templateUrl: './reporte-prospeccion.component.html',
    styleUrls: ['./reporte-prospeccion.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatDateRangePicker, MatButton, NgFor, NgIf, DatePipe, NgxPaginationModule]
})
export class ReporteProspeccion implements OnInit {
    consultaReporte = new ConsultaList<Prospeccion>();
    listaProspectos: Array<Prospeccion> = [];
    totalRegistros = 0;
    readonly pageSize = 10;
    currentPage = 1;
    public labels: { previousLabel: string; nextLabel: string } = {
        previousLabel: 'ANTERIOR',
        nextLabel: 'SIGUIENTE'
    };
    fecha_inicio: Date;
    fecha_fin: Date;
    busquedaForm: FormGroup;

    constructor(
        private clientService: GestionclientesService, private formBuilder: FormBuilder ){ }

    ngOnInit() {
        this.busquedaForm = this.formBuilder.group({
            fechaInicial: [''],
            fechaFinal: ['']
        });
        this.consultaPagina(1);
    }

    onStartDateChange(event: MatDatepickerInputEvent<Date>) {
        if(event){
          this.fecha_inicio = event.value;
        }
      }
    
      onEndDateChange(event: MatDatepickerInputEvent<Date>) {
        if(event){
          this.fecha_fin = event.value;
        }
      }

    consultaPagina(page: number): void {
        this.currentPage = page;
        this.consultaReporte.regInicial = (page - 1) * this.pageSize;
        this.consultaReporte.regXPagina = this.pageSize;

        this.clientService.consultaProspectosxUsuarioSeguimiento(this.consultaReporte).subscribe(res => {
            this.totalRegistros = this.resolveTotalRegistros(res);
            this.listaProspectos = Array.isArray(res?.list) ? res.list : [];

            const maxPages = this.totalPages;
            if (maxPages > 0 && this.currentPage > maxPages) {
                this.consultaPagina(maxPages);
            }
        });
    }

filtroBusqueda() {
    this.consultaReporte.fecha_ini = this.fecha_inicio;
    this.consultaReporte.fecha_fin = this.fecha_fin;
    this.consultaPagina(1);
  }

  limpiarFiltros() {
    try {
        this.consultaReporte.fecha_ini = null;
        this.consultaReporte.fecha_fin = null;
        this.consultaReporte.param1 = null;
        this.fecha_inicio = null;
        this.fecha_fin = null;

        this.busquedaForm.get('fechaInicial').setValue('');
        this.busquedaForm.get('fechaFinal').setValue('');

        this.consultaPagina(1);
    } catch (error) {
        console.error("Error al limpiar filtros:", error);
    }
}

get totalPages(): number {
    return this.totalRegistros > 0 ? Math.ceil(this.totalRegistros / this.pageSize) : 0;
}

get showPagination(): boolean {
    return this.totalRegistros > 0 || this.listaProspectos.length > 0;
}

private resolveTotalRegistros(res: ConsultaList<Prospeccion>): number {
    const response = res as ConsultaList<Prospeccion> & Record<string, unknown>;
    const candidates = [
        response?.pTotalItems,
        response?.totalItems,
        response?.totalRegistros,
        response?.param4,
    ];

    for (const candidate of candidates) {
        const parsed = Number(candidate);
        if (Number.isFinite(parsed) && parsed > 0) {
            return parsed;
        }
    }

    const currentItems = Array.isArray(res?.list) ? res.list.length : 0;
    if (currentItems === 0) {
        return 0;
    }

    return ((this.currentPage - 1) * this.pageSize) + currentItems;
}

}
